module.exports = __webpack_public_path__ + "static/media/Construction-Villa-Vaud.688491a7.jpg";